import { useHistory } from "react-router-dom";
// import SlateEditor from "../DesignEditor/SlateEditor";

function CreateNewDesign() {
  const history = useHistory();
  if (!localStorage.getItem("skiUserToken")) history.push("/");
  return (
    <>
      <div>Canvas editor</div>
      {/* <SlateEditor /> */}
    </>
  );
}
export default CreateNewDesign;
